<template>
  <div class="sucesso-page">
    <div class="card sucesso-card">
      <div v-if="loading" class="state-block">
        <div class="loader" />
      </div>

      <template v-else-if="inscricao">
        <div class="icon-success">✅</div>
        <h1>Inscrição confirmada!</h1>
        <p class="msg">
          <strong>{{ inscricao.participanteNome }}</strong>, sua inscrição em
          <strong>{{ inscricao.evento.nome }}</strong> está registrada.
        </p>

        <div class="resumo">
          <div class="resumo-row">
            <span>Plano</span>
            <strong>{{ inscricao.plano.nome }}</strong>
          </div>
          <div class="resumo-row" v-if="inscricao.total > 1">
            <span>Parcelas pagas</span>
            <strong>{{ inscricao.pagas }} de {{ inscricao.total }}</strong>
          </div>
          <div class="resumo-row">
            <span>Status</span>
            <strong>{{ statusLabel }}</strong>
          </div>
        </div>

        <p v-if="inscricao.statusPagamento !== 'QUITADA'" class="parcial-help">
          As próximas parcelas vão ser cobradas automaticamente. Quando vencer,
          você receberá um lembrete e poderá pagar a parcela pelo link.
        </p>

        <router-link
          v-if="inscricao.statusPagamento === 'QUITADA' && inscricao.evento?.temCheckin"
          :to="`/inscricao/${inscricao.id}/qr`"
          class="btn-primary back"
        >
          Ver meu código de check-in
        </router-link>
        <a href="https://naelshaday.com.br" class="btn-secondary back">Voltar ao site da igreja</a>
      </template>

      <div v-else class="state-block">
        <div class="state-icon">⚠️</div>
        <p>Inscrição não encontrada.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getSucesso } from '../../lib/inscricao'

const STATUS_LABEL = {
  PENDENTE: 'Aguardando 1º pagamento',
  PARCIAL: 'Parcialmente pago',
  QUITADA: 'Tudo pago',
  ATRASADA: 'Parcela em atraso'
}

export default {
  name: 'SucessoPage',
  data() { return { loading: true, inscricao: null } },
  computed: {
    statusLabel() {
      return STATUS_LABEL[this.inscricao?.statusPagamento] || this.inscricao?.statusPagamento
    }
  },
  async mounted() {
    try {
      this.inscricao = await getSucesso(this.$route.params.inscricaoId)
    } catch {}
    this.loading = false
  }
}
</script>

<style scoped>
.sucesso-page {
  min-height: calc(100vh - 60px);
  display: flex; justify-content: center; align-items: flex-start;
  padding: var(--spacing-lg) var(--spacing-base);
}
.sucesso-card {
  width: 100%; max-width: 520px;
  padding: var(--spacing-xl);
  text-align: center;
  display: flex; flex-direction: column; align-items: center; gap: var(--spacing-md);
}
.icon-success { font-size: 64px; }
h1 { font-size: var(--text-2xl); color: var(--color-success); }
.msg { color: var(--color-text-secondary); }
.resumo {
  width: 100%;
  display: flex; flex-direction: column; gap: var(--spacing-sm);
  background: var(--color-bg-hover);
  padding: var(--spacing-base);
  border-radius: var(--radius-md);
  margin-top: var(--spacing-md);
}
.resumo-row {
  display: flex; justify-content: space-between;
  font-size: var(--text-sm);
}
.resumo-row span { color: var(--color-text-muted); }
.parcial-help {
  font-size: var(--text-sm); color: var(--color-text-muted);
  background: #f0f9ff; padding: var(--spacing-md);
  border-radius: var(--radius-md);
  margin-top: var(--spacing-md);
}
.back { margin-top: var(--spacing-lg); text-decoration: none; }
.state-block {
  display: flex; flex-direction: column; align-items: center; gap: var(--spacing-md);
  padding: var(--spacing-xl) 0;
}
.state-icon { font-size: 48px; }
.loader {
  width: 32px; height: 32px;
  border: 3px solid var(--color-bg-separator);
  border-top-color: var(--color-accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
